import { Endpoint } from '../endpoint';
import { CompanyId } from '@business/entities/companies';
import { GroupId, GroupResponse } from '@business/entities/group';

export function fetchGroups(companyId: CompanyId, isCompact?: boolean, filter?: string) {
  return Endpoint.get<GroupResponse[]>(`@makh/groups`, { params: { companyId, isCompact, filter } });
}

export function fetchGroup(id: GroupId) {
  return Endpoint.get<GroupResponse>(`@makh/groups/group/${id}`);
}

export function createGroup(data: Partial<GroupResponse>) {
  return Endpoint.post<GroupResponse>(`@makh/groups`, { data });
}

export function updateGroup(groupId: GroupId, data: Partial<GroupResponse>) {
  return Endpoint.patch<GroupResponse>(`@makh/groups/${groupId}`, { data });
}

export function deleteGroup(groupId: GroupId) {
  return Endpoint.delete<void>(`@makh/groups/${groupId}`);
}
